import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useLayoutEffect, useState } from 'react';
import { SignIn } from 'app/components/sing-in/sign-in';
import { HOME_PATH } from 'app/route/paths';
import { AUTH_TOKEN } from 'app/constants';
import { decodeJWT } from 'app/components/utils/utils';

export const OpenRoutes = () => {
  const location = useLocation();

  const [loggedIn, setLoggedIn] = useState(false);

  useLayoutEffect(() => {
    const validToken = (): boolean => {
      const token = localStorage.getItem(AUTH_TOKEN);
      if (!token) return false;
      const decodedToken = JSON.parse(decodeJWT(token))

      if (decodedToken.exp * 1000 < Date.now()) {
        return false;
      }
      if (decodedToken.assignment != "user_session") {
        return false;
      }
      return true;
    }

    if (validToken()) {
      setLoggedIn(true);
    }
  }, []);


  return loggedIn ? <Navigate to={HOME_PATH} replace state={{ from: location }} /> : <Outlet />;
};
